<template>
  <div class="free-home">
    <img class="nf-top" src="../assets/nf-top.jpg" alt="" />

    <div class="middle">
      <div class="order">
        <div>
          <van-button
            class="vant-btn"
            round
            size="small"
            text="开始点餐"
            to="searchShop"
          ></van-button>
          <div style="margin-top: 10px; margin-left: 6px">
            <span class="order-tips">提前15分钟点餐</span
            ><span class="order-tips" style="margin-left: 10px"
              >到店取餐/不支持外卖</span
            >
          </div>
          <div style="margin-top: 5px; margin-left: 6px">
            <span class="order-time">营业时间：8:00-21:00</span>
          </div>
        </div>
        <img class="nf-shop" src="../assets/nf_shop.png" alt="" />
      </div>
      <div class="rows">
        <div class="rows-item" @click="handleClickJump('historyOrder')">
          <div class="rows-tips">我的订单</div>
          <div class="rows-look">查看取餐口令</div>
        </div>
        <img
          class="rows-icon"
          src="../assets/nf-order.png"
          alt=""
          @click="handleClickJump('historyOrder')"
        />
        <div class="rows-item" @click="handleClickJump('service')">
          <div class="rows-tips">在线客服</div>
          <div class="rows-look">有问题点我咨询</div>
          <div class="rows-thin">客服热线：400-0808-910</div>
        </div>
        <img
          class="rows-icon right"
          src="../assets/nf-kefu.png"
          alt=""
          @click="handleClickJump('service')"
        />
      </div>
    </div>

    <div class="footer-text"><span>本产品为第三方代点餐服务</span><br /></div>
  </div>
</template>
<script>
import { Button } from "vant";
import { getPlatformPayWay } from "@/request/api";
export default {
  name: "loginFree",
  components: {
    [Button.name]: Button,
  },
  data(){
    return{
      platformCode:"1f"
    }
  },
  beforeMount(){
    this.platformCode = this.$getUrlParam('platformCode') ||this.$getUrlParam('id')
  },
  created() {
    // console.log(this.$router.history);
    if (history && history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.goback, false);
    }
  },
  mounted(){
    
    // getPlatformPayWay({code:this.platformCode || '1f'}).then(res=>{
    //     if(res.payTypeH5 && res.payTypeWx){
    //       localStorage.setItem('payWay',JSON.stringify({payH5:res.payTypeH5,payWx:res.payTypeWx}))
    //     }else{
    //       localStorage.setItem('payWay',JSON.stringify({payH5:3,payWx:2}))
    //     }
    //   })
  },
  beforeDestroy() {
    window.removeEventListener("popstate", this.goback);
  },
  methods: {
    handleClickJump(url) {
      this.$router.push(url);
    },
    goback() {
      history.go(-2);
    },
    
  },
};
</script>

<style scoped>
.free-home {
  background-color: #f5f5f5;
  height: 100%;
}
.nf-top {
  object-fit: cover;
  width: 100%;
  padding: 0;
}
.nf-shop {
  object-fit: contain;
  width: 68px;
  display: block;
  margin-bottom: -5px;
}
.middle {
  /* max-height: 300px; */
}
.order {
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin: -0.6rem auto 0 auto;
  padding: 15px;
  border-radius: 10px;
  box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.116);
  width: 90%;
  /* height: 125px; */
  min-height: 3rem;
  background-color: #fff;
}
.rows {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin: 14px auto 0 auto;
  border-radius: 10px;
  width: 90%;
}
.rows-item {
  background-color: #fff;
  padding: 0.1rem 0.4rem;
  width: 48%;
  min-height: 2.9rem;
  box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.116);
  border-radius: 10px;
}
.rows-tips {
  font-size: 16px;
  font-weight: 600;
  margin-top: 0.2rem;
}
.rows-look {
  font-size: 13px;
  font-weight: 600;
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
  color: #b28850;
}
.rows-thin {
  font-size: 12px;
  transform: scale(0.64);
  color: #b28850;
  margin-left: -28px;
  font-weight: 600;
  margin-top: -3px;
}
.rows-icon {
  position: absolute;
  margin-left: 25%;
  margin-top: -15px;
  width: 1.6rem;
}
.right {
  margin-left: 72%;
}

.order-tips {
  font-size: 12px;
  color: #212121;
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
  font-weight: 600;
}
.order-time {
  font-size: 14px;
  color: #b28850;
}
.vant-btn {
  width: 130px;
  height: 40px;
  background-color: #006e3f;
  color: #fff;
  font-size: 18px;
  font-weight: 400;
  line-height: 0.2rem;
}
.footer-text {
  text-align: center;
  position: absolute;
  top: auto;
  left: 0;
  right: 0;
  bottom: 0.3rem;
  color: #999999;
  line-height: 18px;
  font-size: 12px;
}
</style>